// AADHYAA - Expert Mode Context
// Global state for expert view toggle
// Phase 3: Expert Mode Implementation

import React, { createContext, useContext, useState, useEffect } from 'react';

const ExpertModeContext = createContext({
  expertMode: false,
  toggleExpertMode: () => {},
  setExpertMode: () => {}
});

export const ExpertModeProvider = ({ children }) => {
  // Initialize from localStorage if available
  const [expertMode, setExpertModeState] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('aadhyaa_expert_mode');
      return saved === 'true';
    }
    return false;
  });

  // Persist to localStorage
  useEffect(() => {
    localStorage.setItem('aadhyaa_expert_mode', String(expertMode));
  }, [expertMode]);

  const toggleExpertMode = () => {
    setExpertModeState(prev => !prev);
  };

  const setExpertMode = (value) => {
    setExpertModeState(value);
  };

  return (
    <ExpertModeContext.Provider value={{ expertMode, toggleExpertMode, setExpertMode }}>
      {children}
    </ExpertModeContext.Provider>
  );
};

export const useExpertMode = () => {
  const context = useContext(ExpertModeContext);
  if (!context) {
    throw new Error('useExpertMode must be used within ExpertModeProvider');
  }
  return context;
};

export default ExpertModeContext;
